import * as Popover from "@radix-ui/react-popover";
import { AnimatePresence, motion } from "framer-motion";
import { useFilter } from "./FilterContext";
import { FilterTrigger } from "./FilterTrigger";
import { FilterCategoryPicker } from "./FilterCategoryPicker";
import { FilterValuePicker } from "./FilterValuePicker";

export function FilterPopover() {
  const { step, isOpen, openPopover, closePopover } = useFilter();

  const showCategoryPicker = step.type === "category_picker";
  const showValuePicker =
    step.type === "value_picker" || step.type === "editing_pill";

  return (
    <Popover.Root
      open={isOpen}
      onOpenChange={(open) => {
        if (open) {
          openPopover();
        } else {
          closePopover();
        }
      }}
    >
      <Popover.Trigger asChild>
        <FilterTrigger />
      </Popover.Trigger>

      <Popover.Portal>
        <Popover.Content
          side="bottom"
          align="start"
          sideOffset={4}
          className="bg-card rounded-[12px] border border-border shadow-lg z-50 data-[state=open]:animate-dropdown-in data-[state=closed]:animate-dropdown-out overflow-hidden"
          onOpenAutoFocus={(e) => e.preventDefault()}
        >
          <AnimatePresence mode="wait" initial={false}>
            {showCategoryPicker && (
              <motion.div
                key="category-picker"
                initial={{ x: -20, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: -20, opacity: 0 }}
                transition={{ duration: 0.15, ease: "easeOut" }}
              >
                <FilterCategoryPicker />
              </motion.div>
            )}

            {showValuePicker && (
              <motion.div
                key="value-picker"
                initial={{ x: 20, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: 20, opacity: 0 }}
                transition={{ duration: 0.15, ease: "easeOut" }}
              >
                <FilterValuePicker />
              </motion.div>
            )}
          </AnimatePresence>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
